import {
  ActiveStatusEnum,
  GenericEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { OnHandReportListingEnum } from 'Common/FieldEnum';

export const BASE_URL = '/onhandreport';

export const INITIAL_VALUES = {
  [OnHandReportListingEnum.ItemStatus]: ActiveStatusEnum.Active,
  [OnHandReportListingEnum.BidGroup]: GenericEnum.InitialFilterValue,
  [OnHandReportListingEnum.ItemGroup]: GenericEnum.InitialFilterValue,
  [OnHandReportListingEnum.AccountCategory]: GenericEnum.InitialFilterValue,
  [OnHandReportListingEnum.VendorId]: GenericEnum.InitialFilterValue,
  [OnHandReportListingEnum.SiteIds]: [],
  [OnHandReportListingEnum.ItemIds]: [],
};

export const activeStatusOptions = [
  {
    key: 0,
    value: ActiveStatusEnum.Active,
    text: 'Active',
  },
  {
    key: 1,
    value: ActiveStatusEnum.Inactive,
    text: 'Inactive',
  },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/helper/listing.js